module.exports = __webpack_public_path__ + "img/yizhengtc.2deee0ad.png";